export default (paramName) => ({
    init() {
        this._handler = () => {
            const u = new URL(window.location);
            u.searchParams.set(paramName, this.$el.value);
            history.replaceState({}, '', u);
        };
        this.$el.addEventListener('change', this._handler);
    },

    destroy() {
        this.$el.removeEventListener('change', this._handler);
    }
});
